import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import es from 'vuetify/src/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es',
  },
  theme: {
    themes: {
      light: {
        'color-0': '#c19d43',
        'color-1': '#be6043',
        'color-2': '#658b6f',
        'color-3': '#99aead',
        'color-4': '#28363d',
        'color-5': '#dee1dd',
        'color-leche': '#B39DDB',
        'light-gray': '#eeeeee'
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
})
